import {ChangeDetectorRef, Component, EventEmitter, inject, OnDestroy, signal, WritableSignal} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ITextFormElement} from '../../components/control/form-control/dynamic-form/form-element/form-data.interface';
import {GuidTableControlComponent} from './guid-table-control/guid-table-control.component';
import {
  TextElementComponent
} from '../../components/control/form-control/dynamic-form/form-element/text-element/text-element.component';
import {GuidSearchBase} from '../guid-search.base';
import {MatAutocomplete} from '@angular/material/autocomplete';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'kpi4me-guid-table',
  templateUrl: './guid-table.component.html',
  styleUrls: ['./guid-table.component.scss'],
  standalone: true,
  imports: [TextElementComponent, GuidTableControlComponent, MatAutocomplete, MatOption],
})
export class GuidTableComponent extends GuidSearchBase implements OnDestroy {
  private _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  tableGuidForm: FormControl<string> = new FormControl('');
  tableGuidFormData: ITextFormElement = {
    label: 'Tabellen selectionGUID',
    inputType: 'text',
    required: false
  };
  render: WritableSignal<boolean> = signal<boolean>(false);
  tableGuid: WritableSignal<string> = signal<string>(null);

  private _tableGuidChange$: EventEmitter<any> = new EventEmitter();
  private _subs: Subscription = new Subscription();

  constructor() {
    super();
    this._subs.add(
      this._tableGuidChange$.subscribe((guid): void => {
        this.render.set(false);
        this.tableGuid.set(guid);
        this._cdr.detectChanges();
        this.render.set(true);
        console.log('guid change', guid);
      })
    );

    this._subs.add(
      this.tableGuidForm.valueChanges.subscribe((value: string): void => {
        this.onGuidInputChanged(value);
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  protected applyGuidValue(value: string): void {
    this.tableGuidForm.setValue(value, {emitEvent: false});
    this._tableGuidChange$.emit(value);
  }
}
